/* ============================================================================
PO / K5 Keyboard — TriLang FR/EN/ES + Lexicon Protection + Notranslate
- Traduction uniquement via boutons FR/EN/ES du bloc
- Protection lexique canonique (window.PO_LEXICON si dispo) + variantes
- Anti Google Translate / navigateur sur le bloc
- Navigation des boutons data-po-target
- Multi-instances Shopify-safe

✅ RÈGLE APPLIQUÉE :
- Tout ce qui est du lexique canonique (data-po-lex) reste TOUJOURS en français
- Tout le reste (slots généraux) peut être traduit FR/EN/ES
============================================================================ */
(function(){
  "use strict";
  if (window.__PO_K5_TRILANG_PROTECTED_20260304__) return;
  window.__PO_K5_TRILANG_PROTECTED_20260304__ = true;

  var STORAGE_KEY = "po_k5_lang";

  function normLang(raw){
    var s = String(raw || "").toLowerCase().trim().replace("_","-");
    if (s.indexOf("en") === 0) return "en";
    if (s.indexOf("es") === 0 || s.indexOf("pt") === 0) return "es";
    return "fr";
  }

  function getLang(){
    try{
      var v = localStorage.getItem(STORAGE_KEY);
      if (v) return normLang(v);
    }catch(_){}
    return "fr";
  }

  function setLang(lang){
    var l = normLang(lang);
    try{ localStorage.setItem(STORAGE_KEY, l); }catch(_){}
    applyAll(l);
    return l;
  }

  function toStr(x){ return x == null ? "" : String(x); }

  function escapeHtml(s){
    return toStr(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function escapeRegExp(s){
    return toStr(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function normalizeVariant(s){
    var x = toStr(s);
    x = x.replace(/[’`´]/g, "'");
    x = x.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    x = x.replace(/æ/g, "ae").replace(/Æ/g, "AE");
    try{ x = x.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); }catch(_){}
    return x;
  }

  function lockNoTranslate(root, lang){
    try{
      root.setAttribute("translate","no");
      root.classList.add("notranslate");
      root.setAttribute("lang", lang || "fr");
    }catch(_){}
  }

  /* =========================
     LEXIQUE À PROTÉGER
     ========================= */
  var _protectTerms = null;

  function uniqTerms(list){
    var seen = Object.create(null), out = [];
    function add(x){
      x = toStr(x).trim();
      if (!x) return;
      if (seen[x]) return;
      seen[x] = true;
      out.push(x);

      var v1 = x.replace(/œ/g, "oe").replace(/Œ/g, "OE").replace(/æ/g, "ae").replace(/Æ/g, "AE");
      if (v1 && !seen[v1]) { seen[v1] = true; out.push(v1); }

      var v2 = x.replace(/[’`´]/g, "'");
      if (v2 && !seen[v2]) { seen[v2] = true; out.push(v2); }

      var v3 = normalizeVariant(x);
      if (v3 && !seen[v3]) { seen[v3] = true; out.push(v3); }
    }
    for (var i=0;i<list.length;i++) add(list[i]);
    out.sort(function(a,b){ return b.length - a.length; });
    return out;
  }

  function buildProtectTerms(){
    if (Array.isArray(window.PO_K5_PROTECT_TERMS) && window.PO_K5_PROTECT_TERMS.length){
      return uniqTerms(window.PO_K5_PROTECT_TERMS);
    }

    var src = window.PO_LEXICON;
    if (!Array.isArray(src)){
      if (Array.isArray(window.PO_LEXICON_DATA)) src = window.PO_LEXICON_DATA;
      else if (Array.isArray(window.PO_LEXICON_ENTRIES)) src = window.PO_LEXICON_ENTRIES;
    }

    var out = [
      "Posœnnoïal","Posœnnoïale","Posœnnoïaux","Posœnnoïales",
      "Katûpirsia","Katûvýs","Katûsýs","Katûvýsissence",
      "Isqun","Threnisqun","Balakallpa","Extratinrieur",
      "Mathêsis ontologique posœnnoïale","Annexe 3-6-9"
    ];

    if (Array.isArray(src)){
      for (var i=0;i<src.length;i++){
        var e = src[i];
        if (!e) continue;
        if (e.terms && typeof e.terms === "object"){
          if (e.terms.fr) out.push(e.terms.fr);
        }else{
          if (e.term_fr) out.push(e.term_fr);
          if (e.fr) out.push(e.fr);
          if (e.name) out.push(e.name);
          if (e.label) out.push(e.label);
        }
      }
    }
    return uniqTerms(out);
  }

  function getProtectTerms(){
    if (_protectTerms) return _protectTerms;
    _protectTerms = buildProtectTerms();
    return _protectTerms;
  }

  function protectLexiconInElement(el){
    if (!el) return;
    var txt = el.textContent || "";
    if (!txt.trim()) return;

    var terms = getProtectTerms();
    if (!terms.length) return;

    var safe = escapeHtml(txt);
    var capped = terms.slice(0, 420).map(escapeRegExp);
    if (!capped.length) return;

    try{
      var re = new RegExp("(" + capped.join("|") + ")", "g");
      safe = safe.replace(re, function(m){
        return '<span class="notranslate" translate="no" data-po-lex-protect="1">' + m + '</span>';
      });
      el.innerHTML = safe;
    }catch(_){}
  }

  /* =========================
     CONTENU TRILINGUE K5 (slots généraux)
     ========================= */
  var CONTENT = {
    fr: {
      summary_title: "KATÛPIRSIA 5 – MATRICE-SUBSTRAT",
      summary_meta: "groupes → accès",
      head_title: "Katûpirsia 5 — Clavier",
      head_meta: "groupes → accès",

      block_1_title: "Katûvýs",
      block_2_title: "Katûsýs",
      block_3_title: "Balakallpa",
      block_4_title: "Isqun (ISQ) — Sceaux",
      block_5_title: "Threnisqun — Entités"
    },
    en: {
      summary_title: "KATÛPIRSIA 5 – MATRIX-SUBSTRATE",
      summary_meta: "groups → access",
      head_title: "Katûpirsia 5 — Keyboard",
      head_meta: "groups → access",

      /* Lexique canonique conservé en FR dans ces titres */
      block_1_title: "Katûvýs",
      block_2_title: "Katûsýs",
      block_3_title: "Balakallpa",
      block_4_title: "Isqun (ISQ) — Seals",
      block_5_title: "Threnisqun — Entities"
    },
    es: {
      summary_title: "KATÛPIRSIA 5 – MATRIZ-SUSTRATO",
      summary_meta: "grupos → acceso",
      head_title: "Katûpirsia 5 — Teclado",
      head_meta: "grupos → acceso",

      /* Lexique canonique conservé en FR dans ces titres */
      block_1_title: "Katûvýs",
      block_2_title: "Katûsýs",
      block_3_title: "Balakallpa",
      block_4_title: "Isqun (ISQ) — Sellos",
      block_5_title: "Threnisqun — Entidades"
    }
  };

  function getPack(lang){
    var l = normLang(lang || getLang());
    return CONTENT[l] || CONTENT.fr;
  }

  function normKey(input){
    var s = toStr(input).trim().toLowerCase();
    s = s.replace(/œ/g, "oe").replace(/æ/g, "ae");
    s = s.replace(/[’'`´]/g, "'").replace(/[‐-‒–—―]/g, "-");
    try{ s = s.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); }catch(_){}
    s = s.replace(/[^a-z0-9_-]+/g, "-");
    s = s.replace(/-+/g, "-").replace(/^[-_]+|[-_]+$/g, "");
    return s;
  }

  function pickTerm(entry, lang){
    if (!entry) return "";
    if (entry.terms && typeof entry.terms === "object"){
      return toStr(entry.terms[lang] || entry.terms.fr || "");
    }
    var k1 = "term_" + lang;
    var k2 = "term_fr";
    if (entry[k1]) return toStr(entry[k1]);
    if (entry[k2]) return toStr(entry[k2]);
    if (entry[lang]) return toStr(entry[lang]);
    if (entry.fr) return toStr(entry.fr);
    if (entry.name) return toStr(entry.name);
    if (entry.label) return toStr(entry.label);
    return "";
  }

  function buildLexIndex(){
    var src = window.PO_LEXICON;
    if (!Array.isArray(src)){
      if (Array.isArray(window.PO_LEXICON_DATA)) src = window.PO_LEXICON_DATA;
      else if (Array.isArray(window.PO_LEXICON_ENTRIES)) src = window.PO_LEXICON_ENTRIES;
    }
    if (!Array.isArray(src) || !src.length) return null;

    var exact = Object.create(null);
    var normd = Object.create(null);

    for (var i=0;i<src.length;i++){
      var e = src[i];
      if (!e) continue;
      var id = e.id || e.key || e.slug || e.uid;
      if (!id) continue;

      var idStr = toStr(id);
      exact[idStr] = e;

      var nk = normKey(idStr);
      if (nk && !normd[nk]) normd[nk] = e;
    }
    return { exact: exact, normd: normd };
  }

  function applySlots(root, lang){
    var pack = getPack(lang);
    var nodes = root.querySelectorAll("[data-po5k-slot]");
    for (var i=0;i<nodes.length;i++){
      var el = nodes[i];
      var key = el.getAttribute("data-po5k-slot");
      if (!key) continue;
      if (!Object.prototype.hasOwnProperty.call(pack, key)) continue;
      el.textContent = pack[key];
      protectLexiconInElement(el);
    }
  }

  function applyLexiconTerms(root /*, lang */){
    var idx = buildLexIndex();
    var nodes = root.querySelectorAll("[data-po-lex]");
    for (var i=0;i<nodes.length;i++){
      var el = nodes[i];
      var key = el.getAttribute("data-po-lex");
      if (!key) continue;

      var entry = idx && idx.exact[key] ? idx.exact[key] : null;
      if (!entry && idx){
        var nk = normKey(key);
        if (nk) entry = idx.normd[nk];
      }
      if (!entry && idx){
        var nk2 = normKey(el.textContent || "");
        if (nk2) entry = idx.normd[nk2];
      }

      /* ✅ IMPORTANT : le lexique canonique reste TOUJOURS EN FR */
      if (entry){
        var txtFr = pickTerm(entry, "fr");
        if (txtFr) el.textContent = txtFr;
      }

      if (el.getAttribute("data-po-protect") === "1"){
        try{
          el.setAttribute("translate","no");
          el.classList.add("notranslate");
        }catch(_){}
      }
      protectLexiconInElement(el);
    }
  }

  function setLangButtonsState(root, lang){
    var btns = root.querySelectorAll("[data-po5k-lang]");
    for (var i=0;i<btns.length;i++){
      var b = btns[i];
      var on = (b.getAttribute("data-po5k-lang") === lang);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    }
  }

  function applyOne(root, lang){
    var l = normLang(lang || getLang());
    lockNoTranslate(root, l);

    /* ✅ On ne verrouille plus tout le texte brut du bloc :
       seuls les éléments protégés + le lexique + le root restent notranslate.
       Cela permet aux slots généraux de changer via FR/EN/ES. */
    try{
      var fixedProtected = root.querySelectorAll("[data-po-protect='1']");
      for (var j=0;j<fixedProtected.length;j++){
        fixedProtected[j].setAttribute("translate","no");
        fixedProtected[j].classList.add("notranslate");
      }
    }catch(_){}

    applySlots(root, l);       /* ✅ textes hors lexique = traduisibles */
    applyLexiconTerms(root);   /* ✅ lexique canonique = FR constant */
    setLangButtonsState(root, l);
  }

  function applyAll(lang){
    var l = normLang(lang || getLang());
    var roots = document.querySelectorAll("[data-po5k]");
    for (var i=0;i<roots.length;i++) applyOne(roots[i], l);
    try{
      document.dispatchEvent(new CustomEvent("po:k5:lang", { detail: { lang: l } }));
    }catch(_){}
  }

  function hookLangButtons(){
    document.addEventListener("click", function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest("[data-po5k-lang]") : null;
      if (!btn) return;
      ev.preventDefault();
      setLang(btn.getAttribute("data-po5k-lang") || "fr");
    }, false);
  }

  function hookNavigation(){
    document.addEventListener("click", function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest("[data-po5k] button.po5k__key") : null;
      if (!btn) return;

      var target = (btn.getAttribute("data-po-target") || "").trim();
      if (!target) return;

      try{
        if (target.charAt(0) === "#"){
          var el = document.querySelector(target);
          if (el && el.scrollIntoView){
            el.scrollIntoView({ behavior:"smooth", block:"start" });
          } else {
            location.hash = target;
          }
        } else {
          window.location.href = target;
        }
      }catch(_){}
    }, { passive:true });
  }

  function onReady(fn){
    if (document.readyState === "loading"){
      document.addEventListener("DOMContentLoaded", fn, { passive:true });
    } else {
      fn();
    }
  }

  function init(){
    applyAll(getLang());
  }

  window.PoK5TriLangProtected = {
    init: init,
    setLang: setLang,
    getLang: getLang,
    applyAll: applyAll,
    applyOne: applyOne
  };

  onReady(function(){
    hookLangButtons();
    hookNavigation();
    init();
  });
})();